// api/v1/Report/GetRevenueReport?StoreId=21&fromDate=2025-08-11&toDate=2025-08-12

import { apiClient } from "helpers/api_helper";

export const GetRevenueReport = async (data: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Report/GetRevenueReport`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
export const GetRevenueCollection = async (data: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Report/GetRevenueReportByPaymentType`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};